import React, { useState, useEffect } from "react";
import logo from "../assets/Logo.svg";
import stackedLogo from "../assets/Desert_North_Logo_Stacked.png";
import ContactForm from "./ContactForm";
import "../App.css";

const MenuBar = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  function toggleModal() {
    setModalIsOpen(!modalIsOpen);
  }

  return (
    <div className="menu-bar">
      <div className="menu-bar__left">
        <img className="menu-bar__logo" src={isMobile ? stackedLogo : logo} alt="My Logo" />
      </div>
      {!isMobile && (
        <div className="menu-bar__right">
          <ContactForm buttonText="APPLY NOW" />
        </div>
      )}
      {isMobile && (
        <div className="menu-bar__mobile-right">
          <ContactForm buttonText="APPLY NOW" />
        </div>
      )}
    </div>
  );
};

export default MenuBar;
